export function init(){
  $('body').on('click', '.make-a-return-osmose', sendOrderId);
};

function sendOrderId(event) {
  const orderId = event.currentTarget.dataset.osmoseId;
  const currentLink = cube.$id('btn-make-return-osmose').getAttribute('href');
  const newLink = `${currentLink}?orderId=${orderId}`;

  cube.$id('btn-make-return-osmose').setAttribute('href', newLink);
}



// WEBPACK FOOTER //
// ./src/modules-es5/account/order/osmoseModal.js